import React from 'react';

const MyIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="7" viewBox="0 0 13 7" fill="none">
        <path
            d="M1.14062 1L6.14062 5.5L11.1406 1"
            stroke="#333333"
            strokeWidth={"2"}
            strokeLinecap={"round"}
            strokeLinejoin={"round"}
        />
    </svg>
);

export default MyIcon;
